import { useChartTheme } from './chartTheme';

export interface RankedBarItem {
  label: string;
  value: number;
  valueLabel: string;
}

interface RankedBarsProps {
  items: RankedBarItem[];
}

const RankedBars = ({ items }: RankedBarsProps) => {
  const t = useChartTheme();
  const max = Math.max(...items.map((i) => i.value), 1);

  return (
    <ul className="flex flex-col gap-3">
      {items.map((item) => (
        <li key={item.label} className="flex flex-col gap-1">
          <div className="flex items-baseline justify-between gap-3">
            <span className="truncate text-sm text-gray-700 dark:text-gray-200" title={item.label}>
              {item.label}
            </span>
            <span className="shrink-0 text-sm font-semibold tabular-nums text-gray-900 dark:text-white">
              {item.valueLabel}
            </span>
          </div>
          <div className="h-2 overflow-hidden rounded-full bg-gray-100 dark:bg-gray-800">
            <div
              className="h-full rounded-full"
              style={{
                width: `${Math.max((item.value / max) * 100, 2)}%`,
                backgroundColor: t.series[0],
              }}
            />
          </div>
        </li>
      ))}
    </ul>
  );
};

export default RankedBars;
